export const API_BASE_URL = 'https://newdemoshop.nshiftportal.com/api';
